var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnHeaderAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 30.7568C18.5002 31.151 18.591 31.5412 18.7669 31.9053C18.9429 32.2694 19.2006 32.6002 19.5255 32.8787C19.8505 33.1573 20.2361 33.3782 20.6606 33.5289C21.085 33.6796 21.5399 33.757 21.9992 33.7568C22.9267 33.7565 23.816 33.4404 24.4723 32.878C25.1286 32.3156 25.4983 31.5528 25.5 30.7568",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.2568C26.8325 10.2568 30.75 14.1743 30.75 19.0068V26.1494L31.124 26.3662L31.6582 26.6758C32.3338 27.0669 32.75 27.7887 32.75 28.5693C32.7498 29.7774 31.7706 30.7567 30.5625 30.7568H13.4375C12.2294 30.7567 11.2502 29.7774 11.25 28.5693C11.25 27.8375 11.6155 27.1574 12.2178 26.7529L12.3418 26.6758L12.876 26.3662L13.25 26.1494V19.0068C13.25 14.1743 17.1675 10.2568 22 10.2568Z",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_744_16515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.742 7.60488C32.0598 7.21011 31.2858 7.00152 30.4975 7C29.8075 7.00024 29.1268 7.15919 28.5081 7.46454C27.8893 7.76989 27.3491 8.21347 26.9291 8.76097C26.5092 9.30847 26.2208 9.94522 26.0863 10.622C25.9518 11.2987 25.9748 11.9974 26.1534 12.6638C26.4097 13.6202 26.9743 14.4652 27.7597 15.0681C28.5451 15.6709 29.5074 15.9978 30.4975 15.9982C31.1879 15.9987 31.8692 15.8403 32.4886 15.5353C33.108 15.2303 33.6488 14.7868 34.0693 14.2392C34.4898 13.6916 34.7786 13.0545 34.9134 12.3774C35.0482 11.7003 35.0254 11.0012 34.8466 10.3343C34.6947 9.76237 34.4304 9.22642 34.069 8.75778C33.7077 8.28914 33.2566 7.89721 32.742 7.60488Z",
    fill: "#DB0046"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_744_16515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(26 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnHeaderAlert);
export default __webpack_public_path__ + "static/media/btn_header_alert.6752af69b84d0c781c7a112bef7d5f06.svg";
export { ForwardRef as ReactComponent };